import { RequestType, RequestTypeKeys, RequestTypeValues, RequestStatus, RequestStatusKeys, RequestStatusValues, PaymentType, PaymentTypeKeys, PaymentTypeValues, DocumentType, DocumentTypeKeys, DocumentTypeValues, PaymentCycleType, PaymentCycleTypeKeys, PaymentCycleTypeValues, LogMessages, LogMessagesKeys, LogMessagesValues, TaxInfoType, TaxInfoTypeKeys, TaxInfoTypeValues } from '@/types/constants';

export const getRequestTypeValue = (key: RequestTypeKeys): RequestTypeValues => {
  return RequestType[key];
}

export const getRequestStatusTypeValue = (key: RequestStatusKeys ): RequestStatusValues => {
  return RequestStatus[key];
}

export const getPaymentTypeValue = (key: PaymentTypeKeys): PaymentTypeValues => {
  return PaymentType[key];
}

export const getDocumentTypeValue = (key: DocumentTypeKeys): DocumentTypeValues => {
  return DocumentType[key];
}

export const getPaymentCycleTypeValue = (key: PaymentCycleTypeKeys): PaymentCycleTypeValues => {
  return PaymentCycleType[key];
}

export const getLogMessageValue = (key: LogMessagesKeys): LogMessagesValues => {
  return LogMessages[key];
}

export const getTaxInfoTypeValue = (key: TaxInfoTypeKeys): TaxInfoTypeValues => {
  return TaxInfoType[key];
}